export const createRedirectLocation = (link, redirect) => ({
  pathname: link,
  state: {
    redirect,
  },
});

export const redirectToPreviousLocation = (router, redirectLocation, defaultLocation) => {
  if (redirectLocation) {
    router.replace(redirectLocation);
  } else {
    router.push(defaultLocation);
  }
};
